import API from '../api';

export const getMyInfo = () => API.get('/api/v1/user/me');

export const updateMyInfo = (data) => API.put(`/api/v1/profiles/${data.id}`, data);

export const changePassword = (data) => API.post(`/api/v1/new/password`, data);

export const getHeaderInfo = () => API.get('/api/v1/user/header-info');
